import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
 
@Component({
  selector: 'app-fee-templet-dialog-box',
  templateUrl: './fee-templet-dialog-box.component.html',
  styleUrls: ['./fee-templet-dialog-box.component.scss'],
})
export class FeeTempletDialogBoxComponent implements OnInit {
  feeTempletForm: FormGroup;
  list;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  SubCast = false;
  isDelete = false;
  FTdisable = false;
  isUpdate = false;
  purposeList: any;
  filteredpurposeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  filteredAdModeList: any;
  AdModeList: any;
  categoryList: any;
  filteredCategoryList: any;
  submitpayload: any;
  FeeTempletList: any;
  FeeTemplateId: any;
  APIService: string;
  castList: any;
  feeHeadArray: FormArray;
  filteredcastList: any;
  SRList: any;
  Table = true;
  filteredSR: any;
  FeeHeadList: any;
  CurrencyList: any;
  filteredCurrencyList: any;
  filteredHeadList: any;
  myFormValueChanges;
  FeeTable: any;
  lvl: 0;
  arr = [];
  inputTimeout: any;
  totalAmount = 0;
  values: any;
  arrTest: any = [];
  FeesTable = [];
  FeesGrid: any;
  errMsg: any;
  feeList: any;
  filteredfeeList: any;
  feeCreate = true;
  feeUpdate = true;
  feeDelete = true;
  FeeLvlShow = false;
  FeeExam = false;
  StuType = true;
  StuStatus = true;
  AdmMode = true;
  ScRes = true;
  Handi = true;
  ScQuota = true;
  Cast = true;
  Curr = true;
  userPermission: any;
  utp: any;
  headdList: any[] = [];
  filteredheaddList: any[] = [];
  tbRow: any[] = [];
  availableOptions: any[] = []; // Make a copy of the original JSON data
  selectedOptions: any[] = [];
  arrayy;
  FeeTemplateSearch: FormGroup;
  feeTempList: any;
  FeeType: string;
  feeLvlList: any;
  filteredfeeLvlList: any;
  examList: any;
  filteredListExam: any;
  InstId: any;
  TypeShow = false;
  SubCountShow = false;
  selectedExamSubCount: number = 0;

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<FeeTempletDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }
  dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.FeeType = '';
    window.scroll(0, 0);
    this.SubCast = false;
    this.FeeLvlShow = false;
    this.FeeExam = false;
    this.StuType = true;
    this.StuStatus = true;
    this.AdmMode = true;
    this.ScRes = true;
    this.Handi = true;
    this.ScQuota = true;
    this.Cast = true;
    this.Curr = true;
    this.arr = [];
    this.TypeShow = false;
    this.SubCountShow = false;
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach((element) => {
        if (element.PageName == 'Fee Template' && element.PCreate == false) {
          this.feeCreate = false;
        }
        if (element.PageName == 'Fee Template' && element.PUpdate == false) {
          this.feeUpdate = false;
        }
        if (element.PageName == 'Fee Template' && element.PDelete == false) {
          this.feeDelete = false;
        }
      });
    }

    this.list = true;
    this.lvl = 0;
    this.totalAmount = 0;
    this.feeTempletForm = this.fb.group({
      TemplateName: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
      ]),
      TemplateCode: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
      ]),
      StudentType: new FormControl('', [Validators.required]),
      StudentStatus: new FormControl('', [Validators.required]),
      constitutional: new FormControl('', [Validators.required]),
      // Caste: new FormControl(''),
      FeeType: new FormControl('', [Validators.required]),
      FeeLevel: new FormControl(''),
      EmId: new FormControl(''),
      StuStype: new FormControl(''),
      SubCount: new FormControl(''),
      SocialReservation: new FormControl('', [Validators.required]),
      IsHandicap: new FormControl('', [Validators.required]),
      SchemaQuota: new FormControl('', [Validators.required]),
      AdmissionMode: new FormControl('', [Validators.required]),
      feeHeadArray: new FormArray([]),
      Currency: new FormControl('', [Validators.required]),
    });
    this.getScretData()
    this.fetchStudentType();
    this.fetchStudentStatus();
    this.fetchAddmissionMode();
    this.getFeeTempletData();
    this.fetchConstiCast();
    this.fetchSocialReservation();
    this.fetchCurrency();
    this.getFeeHeadData();
    this.getExamList();
    this.addNewRow();
    this.fetchFeeType();
    this.feeTempletForm.controls['Currency'].setValue('INR');
    if (this.data.key == 'Edit') {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == 'Delete') {
      this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key)
    }
    this.FeeTemplateSearch = this.fb.group({
      SearchString: new FormControl(''),
    });
    // if (this.data.key == "Edit") {
    //   this.prepopulation(this.data.selected);
    // } else if (this.data.key == "Delete") {
    //   this.prepopulationForDelete(this.data.selected);
    // } else {
    //   // alert(this.data.key)
    // }

    // Subscribe to changes in the form array
    this.feeTempletForm.get('feeHeadArray').valueChanges.subscribe((values) => {
      this.checkForDuplicates(values);
    });
    // Subscribe to EmId changes to get selected exam's SubCount
    this.feeTempletForm.get('EmId').valueChanges.subscribe((emId) => {
      if (emId) {
        const selectedExam = this.examList.find(exam => exam.EmId == emId);
        if (selectedExam) {
          this.selectedExamSubCount = selectedExam.SubCount || 0;
          // Update SubCount validation when exam changes
          if (this.SubCountShow) {
            this.updateSubCountValidation();
          }
        }
      }
    });
  }

  onTypeChange(typeValue: string) {
    if (typeValue === 'R') {
      this.SubCountShow = true;
      this.updateSubCountValidation();
    } else {
      this.SubCountShow = false;
      this.feeTempletForm.controls['SubCount'].clearValidators();
      this.feeTempletForm.controls['SubCount'].updateValueAndValidity();
      this.feeTempletForm.controls['SubCount'].setValue('');
    }
  }
  updateSubCountValidation() {
    const validators = [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.min(1)
    ];
    if (this.selectedExamSubCount > 0) {
      validators.push(Validators.max(this.selectedExamSubCount));
    }
    
    this.feeTempletForm.controls['SubCount'].setValidators(validators);
    this.feeTempletForm.controls['SubCount'].updateValueAndValidity();
  }

  getSubCountError() {
    const subCountControl = this.feeTempletForm.controls['SubCount'];
    
    if (subCountControl.hasError('required')) {
      return 'Mandatory';
    }
    
    if (subCountControl.hasError('pattern')) {
      return 'Invalid';
    }
    
    if (subCountControl.hasError('max')) {
      const maxValue = subCountControl.errors['max'].max;
      return `Maximum value is ${maxValue}`;
    }
    
    return '';
  }

  keypress() {
    this.umsService.searchFeeTemplate(this.FeeTemplateSearch.value).subscribe(
      (res) => {
        this.FeeTempletList = res.data;
      },
      (ERROR: HttpErrorResponse) => {
        this.FeeTempletList = [];
      }
    );
  }

  getfeeHeadArrayControls() {
    return (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
  }

  getFeeTempletData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFeeTemplet(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.FeeTempletList = res.data;
        } else {
          this.spinner.hide();
          this.FeeTempletList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.FeeTempletList = [];
      }
    );
  }

  addNewRow2(i, e) {
    this.arr = this.feeTempletForm.controls.feeHeadArray.value;
    this.feeHeadArray = this.feeTempletForm.get('feeHeadArray') as FormArray;
    if (this.feeHeadArray.invalid) {
      this.feeHeadArray.controls.forEach((element) => {
        element.get('FeeHead').markAsTouched();
        // element.get('ClgUni').markAsTouched();
        // element.get('Purpose').markAsTouched();
        element.get('FeeAmount').markAsTouched();
      });
    } else {
      this.lvl = this.feeTempletForm.controls.feeHeadArray.value.length;
      this.arr = this.feeTempletForm.controls.feeHeadArray.value;
      const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
      creds.push(
        this.fb.group({
          FeeHead: new FormControl('', [Validators.required]),
          ClgUni: new FormControl(''),
          Purpose: new FormControl(''),
          FeeAmount: new FormControl('', [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
          ]),
        })
      );
      // if(this.lvl >= 1){
      //  this.FeeHeadList =  this.headdList[i] ;
      // }
    }
  }
  errorcheckP(i) {
    return (
      i.controls['FeeAmount'].touched && i.controls['FeeAmount'].errors?.pattern
    );
  }
  errorcheckR(i) {
    return (
      i.controls['FeeAmount'].touched &&
      i.controls['FeeAmount'].errors?.required
    );
  }

  errorcheckH(i) {
    return (
      i.controls['FeeHead'].touched && i.controls['FeeHead'].errors?.required
    );
  }

  addNewRow() {
    const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
    creds.push(
      this.fb.group({
        FeeHead: new FormControl('', [Validators.required]),
        ClgUni: new FormControl(''),
        Purpose: new FormControl(''),
        FeeAmount: new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
        ]),
      })
    );
  }

  checkForDuplicates(values: any) {
    const duplicates = values.filter(
      (value, index, self) =>
        index !== self.findIndex((v) => v.FeeHead === value.FeeHead)
    );

    if (duplicates.length) {
      const data = {
        message: 'Fee Head Already Selected',
        title: 'Information',
        icon: 'fas fa-box-open',
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      duplicates.forEach((duplicate) => {
        const index = values.findIndex((v) => v.FeeHead === duplicate.FeeHead);
        const arrayy = this.feeTempletForm.get('feeHeadArray') as FormArray;
        arrayy.at(index).get('FeeHead').setValue('');
      });
    } else {
      this.arr = this.feeTempletForm.controls.feeHeadArray.value;
    }
  }

  isSelected(feehead: string): boolean {
    return this.arr.some((element) => element.FeeHead === feehead);
  }

  deleteRow(index) {
    if (index !== 0) {
      let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
        .at(index)
        .get('FeeAmount').value;

      if (amountValue == '') {
        amountValue = 0;
      } else {
        amountValue = parseInt(amountValue);
        this.totalAmount = this.totalAmount - parseInt(amountValue);
      }

      (<FormArray>this.feeTempletForm.get('feeHeadArray')).removeAt(index);
      this.arr = this.feeTempletForm.controls.feeHeadArray.value;
    } else {
      let length = this.feeTempletForm.get('feeHeadArray').value.length;
      if (length > 1) {
        let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
          .at(index)
          .get('FeeAmount').value;

        if (amountValue == '') {
          amountValue = 0;
        } else {
          amountValue = parseInt(amountValue);
          this.totalAmount = this.totalAmount - parseInt(amountValue);
        }

        (<FormArray>this.feeTempletForm.get('feeHeadArray')).removeAt(index);
        this.arr = this.feeTempletForm.controls.feeHeadArray.value;
      } else if (length == 1) {
        let data = {};
        data['message'] = 'First Row Can Not Be Deleted';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    }
  }

  // getHead(id, i) {
  //   // const selectedOption = this.feeHeadArray.at(index).get('FeeHead').value;
  //   this.spinner.show();
  //   const payload = {};
  //   payload['FeeHeadId'] = id.FeeHeadId;
  //   this.umsService.getFeeHead(payload).subscribe(
  //     (res) => {
  //       let data = res.data[0];
  //       if (res.status) {
  //         this.spinner.hide();
  //         this.FeeTable = res.data;
  //         this.feeHeadArray = this.feeTempletForm.get(
  //           'feeHeadArray'
  //         ) as FormArray;
  //         if (this.feeHeadArray.value[i]['FeeHead'] != '') {
  //           this.FeeTable.map((element) => {
  //             this.feeHeadArray
  //               .at(i)
  //               .get('ClgUni')
  //               .setValue(element['Uni_Colg']);
  //             this.feeHeadArray
  //               .at(i)
  //               .get('Purpose')
  //               .setValue(element['Purpose']);
  //           });
  //         } else {
  //           this.feeHeadArray.at(i).get('ClgUni').setValue('');
  //           this.feeHeadArray.at(i).get('Purpose').setValue('');
  //         }
  //       } else {
  //         this.spinner.hide();
  //       }
  //     },
  //     (ERROR: HttpErrorResponse) => {
  //       this.spinner.hide();
  //     }
  //   );
  // }

  getHead(id, i, event) {
    if (!event.isUserInput) {
      // Ignore if the change wasn't made by the user (e.g., programmatic change)
      return;
    }
    this.spinner.show();
    const payload = {};
    payload['FeeHeadId'] = id.FeeHeadId;
    this.umsService.getFeeHead(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          const data = res.data[0];
          this.FeeTable = res.data;
          
          this.feeHeadArray = this.feeTempletForm.get('feeHeadArray') as FormArray;
          if (this.feeHeadArray.value[i]['FeeHead'] !== '') {
            this.FeeTable.forEach((element) => {
              this.feeHeadArray.at(i).get('ClgUni').setValue(element['Uni_Colg']);
              this.feeHeadArray.at(i).get('Purpose').setValue(element['Purpose']);
            });
          } else {
            this.feeHeadArray.at(i).get('ClgUni').setValue('');
            this.feeHeadArray.at(i).get('Purpose').setValue('');
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }
  

  onInputChange(event: any, i) {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.getAmount(event, i);
    }, 500);
  }

  getAmount(event: any, i) {
    let arrayData = (<FormArray>this.feeTempletForm.get('feeHeadArray')).at(i);
    let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
      .at(i)
      .get('FeeAmount').value;
    amountValue = parseInt(amountValue);
    const tempData = this.feeTempletForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    this.totalAmount = 0;
    tempData.forEach((element) => {
      if (element.FeeAmount == '') {
        element.FeeAmount = 0;
      }
      this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
    });
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.totalAmount = 0;
      this.list = false;
      this.lvl = 0;
      this.SubCast = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.isDelete = false;
      this.FTdisable = false;
      this.isUpdate = false;
      this.feeTempletForm = this.fb.group({
        TemplateName: new FormControl('', [
          Validators.required,
          Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
        ]),
        TemplateCode: new FormControl('', [
          Validators.required,
          Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
        ]),
        StudentType: new FormControl('', [Validators.required]),
        StudentStatus: new FormControl('', [Validators.required]),
        constitutional: new FormControl('', [Validators.required]),
        FeeType: new FormControl('', [Validators.required]),
        FeeLevel: new FormControl(''),
        EmId: new FormControl(''),
        // Caste: new FormControl(''),
        StuStype: new FormControl(''),
        SubCount: new FormControl(''),
        SocialReservation: new FormControl('', [Validators.required]),
        IsHandicap: new FormControl('', [Validators.required]),
        SchemaQuota: new FormControl('', [Validators.required]),
        AdmissionMode: new FormControl('', [Validators.required]),
        feeHeadArray: new FormArray([]),
        Currency: new FormControl('', [Validators.required]),
      });
      this.addNewRow();
    } else {
      this.list = true;
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
      // this.getFacultyData();
      this.ngOnInit();
    }
  }

  getFeeHeadData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFeeHead(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.FeeHeadList = res.data;
          this.filteredHeadList = this.FeeHeadList.slice();
        } else {
          this.spinner.hide();
          this.FeeHeadList = [];
          this.filteredHeadList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  //   removeOption(item): void {
  //     // const selectedOption = this.FeeHeadList.at(i).get('FeeHead').value;
  //     // const optionIndex = this.FeeHeadList.findIndex(option => option.FeeHeadId === selectedOption.FeeHeadId);
  //     // if (optionIndex !== -1) {
  //     //   this.FeeHeadList.splice(optionIndex, 1);
  //     // }
  //       for (var i = this.FeeHeadList.length - 1; i >= 0; --i) {
  //         if (this.FeeHeadList[i].HeadCode == item.HeadCode) {
  //           this.FeeHeadList.splice(i, 1);
  //         }
  //       }

  //   }

  fetchStudentType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.sTypeList = res.data;
          this.filteredsTypeList = this.sTypeList.slice();
        } else {
          this.spinner.hide();
          this.sTypeList = [];
          this.filteredsTypeList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.sTypeList = [];
        this.filteredsTypeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchSocialReservation() {
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchStudentStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STUST';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.stuStatusList = res.data;
          this.filteredstuStatusList = this.stuStatusList.slice();
        } else {
          this.spinner.hide();
          this.stuStatusList = [];
          this.filteredstuStatusList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.stuStatusList = [];
        this.filteredstuStatusList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchAddmissionMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.AdModeList = res.data;
          this.filteredAdModeList = this.AdModeList.slice();
        } else {
          this.spinner.hide();
          this.AdModeList = [];
          this.filteredAdModeList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.AdModeList = [];
        this.filteredAdModeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchConstiCast() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.castList = res.data;
          this.filteredcastList = this.castList.slice();
        } else {
          this.spinner.hide();
          this.castList = [];
          this.filteredcastList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.castList = [];
        this.filteredcastList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchFeeType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'FT';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.feeList = res.data;
          this.filteredfeeList = this.feeList.slice();
        } else {
          this.spinner.hide();
          this.feeList = [];
          this.filteredfeeList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.feeList = [];
        this.filteredfeeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchFeeLevel() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'FLVL';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.feeLvlList = res.data;
          this.filteredfeeLvlList = this.feeLvlList.slice();
        } else {
          this.spinner.hide();
          this.feeLvlList = [];
          this.filteredfeeLvlList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.feeLvlList = [];
        this.filteredfeeLvlList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  // fetchCast(value) {
  //   this.spinner.show();
  //   if (value == 2) {
  //     this.SubCast = false;
  //   }
  //   else {
  //     this.SubCast = true;
  //   }
  //   this.categoryList = [];
  //   this.filteredCategoryList = [];
  //   const payload = {};
  //   payload['CategoryId'] = parseInt(value);
  //   this.umsService.fetchCategory(payload).subscribe((res) => {
  //     this.spinner.hide()
  //     if (res.status) {
  //       this.categoryList = res.data;
  //       this.filteredCategoryList = this.categoryList.slice();
  //     }
  //     else {
  //       this.filteredCategoryList = [];
  //     }

  //   }, (ERROR: HttpErrorResponse) => {
  //     // this.spinner.hide();
  //     let data = {}
  //     data['message'] = ERROR.error.message
  //     data['title'] = 'Information'
  //     data['icon'] = 'fas fa-box-open'
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //   });

  // }

  FType(feeType) {
    this.FeeLvlShow = false;
    // this.submitpayload = this.feeTempletForm.value;
    this.FeeType = feeType;
    
    // Reset Type and SubCount fields
    this.TypeShow = false;
    this.SubCountShow = false;
    this.feeTempletForm.controls['StuStype'].setValue('');
    this.feeTempletForm.controls['SubCount'].setValue('');
    
    if (this.FeeType == 'EF') {
      this.FTdisable = false;
      this.fetchFeeLevel();
      this.FeeLvlShow = true;
      this.FeeExam = true;
      this.StuType = true;
      this.StuStatus = true;
      this.AdmMode = true;
      this.ScRes = true;
      this.Handi = true;
      this.ScQuota = true;
      this.Cast = true;
      this.Curr = true;
      // this.feeTempletForm.controls['StudentType'].setValue('');
      // this.feeTempletForm.controls['StudentStatus'].setValue('');
      // this.feeTempletForm.controls['AdmissionMode'].setValue('');
      // this.feeTempletForm.controls['SocialReservation'].setValue('');
      // this.feeTempletForm.controls['IsHandicap'].setValue('false');
      // this.feeTempletForm.controls['SchemaQuota'].setValue('');
      // this.feeTempletForm.controls['constitutional'].setValue('');
      this.TypeShow = true;
      this.feeTempletForm.controls['StuStype'].setValidators([Validators.required]);
      this.feeTempletForm.controls['StuStype'].updateValueAndValidity();
    } else if (this.FeeType == 'AF') {
      this.FTdisable = false;
      this.FeeLvlShow = false;
      this.FeeExam = true;
      this.StuType = true;
      this.StuStatus = true;
      this.AdmMode = true;
      this.ScRes = true;
      this.Handi = true;
      this.ScQuota = true;
      this.Cast = true;
      this.Curr = true;
      this.TypeShow = false;
      this.SubCountShow = false;
      this.feeTempletForm.controls['StuStype'].clearValidators();
      this.feeTempletForm.controls['StuStype'].updateValueAndValidity();
      this.feeTempletForm.controls['SubCount'].clearValidators();
      this.feeTempletForm.controls['SubCount'].updateValueAndValidity();
    }
    else if(this.FeeType == 'TC' || this.FeeType == 'LC' ||this.FeeType == 'MC' || this.FeeType == 'ADMC' || this.FeeType == 'TS' || this.FeeType == 'ASC' ){
      
      this.FeeLvlShow = false;
      this.FeeExam = false;
      this.StuType = false;
      this.StuStatus = false;
      this.AdmMode = false;
      this.ScRes = false;
      this.Handi = false;
      this.ScQuota = false;
      this.Cast = false;
      this.Curr = false;
      this.TypeShow = false;
      this.SubCountShow = false;
      this.feeTempletForm.controls['StuStype'].clearValidators();
      this.feeTempletForm.controls['StuStype'].updateValueAndValidity();
      this.feeTempletForm.controls['SubCount'].clearValidators();
      this.feeTempletForm.controls['SubCount'].updateValueAndValidity();
      
      this.feeTempletForm.controls['StudentType'].setValue(['NA']);
      this.feeTempletForm.controls['StudentStatus'].setValue(['NA']);
      this.feeTempletForm.controls['AdmissionMode'].setValue(['NA']);
      this.feeTempletForm.controls['constitutional'].setValue(['GM']);
      this.feeTempletForm.controls['IsHandicap'].setValue('false');
      this.feeTempletForm.controls['SchemaQuota'].setValue(['NA']);
      this.feeTempletForm.controls['SocialReservation'].setValue(['NA']);
      // this.feeTempletForm.controls['constitutional'].setValue('');
      
    }
  }

  save() {
    this.submitpayload = this.feeTempletForm.value;
    if (this.feeTempletForm.invalid) {
      
      this.feeTempletForm.get('TemplateName').markAsTouched();
      this.feeTempletForm.get('TemplateCode').markAsTouched();
      this.feeTempletForm.get('StudentType').markAsTouched();
      this.feeTempletForm.get('StudentStatus').markAsTouched();
      this.feeTempletForm.get('constitutional').markAsTouched();
      // this.feeTempletForm.get('Caste').markAsTouched();
      this.feeTempletForm.get('FeeType').markAsTouched();
      this.feeTempletForm.get('SocialReservation').markAsTouched();
      // this.feeTempletForm.get('JNKMigration').markAsTouched();
      this.feeTempletForm.get('IsHandicap').markAsTouched();
      this.feeTempletForm.get('SchemaQuota').markAsTouched();
      this.feeTempletForm.get('AdmissionMode').markAsTouched();
      this.feeTempletForm.get('Currency').markAsTouched();
      let x = (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
      x.forEach((element) => {
        element['controls']['FeeHead'].markAsTouched();
        element['controls']['FeeAmount'].markAsTouched();
      });
    } else {
      if(this.feeTempletForm.value['FeeType'] === 'TC' || this.feeTempletForm.value['FeeType'] === 'LC' || this.feeTempletForm.value['FeeType'] == 'MC' || this.feeTempletForm.value['FeeType'] == 'TS' || this.feeTempletForm.value['FeeType'] === 'ASC'){
        
        this.findDup()
      }
      else{
        this.submitFeeTemplet();
      }
      
    }
  }

  findDup(){
    
    this.spinner.show();
    const payload = {};
    this.spinner.hide();
    payload['FeeType'] = this.feeTempletForm.value['FeeType'];
    this.umsService.getFeeTclc(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        let data = {};
        data['message'] = 'Template For This FeeType Already Exist';
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
      else{
        this.spinner.hide();
        this.submitFeeTemplet();
      }
    },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.submitFeeTemplet();
    });
  }

  submitFeeTemplet() {
    this.spinner.show();
    this.submitpayload = this.feeTempletForm.value;
    // let AdmissionMode = this.submitpayload.AdmissionMode.join(',');
    let SchemaQuota = this.submitpayload.SchemaQuota.join(',');
    let SocialReservation = this.submitpayload.SocialReservation.join(',');
    let StudentStatus = this.submitpayload.StudentStatus.join(',');
    let StudentType = this.submitpayload.StudentType.join(',');
    let constitutional = this.submitpayload.constitutional.join(',');
    // this.submitpayload['Caste'] = this.feeTempletForm.value.Caste.toString()
    // this.submitpayload['constitutional'] = this.feeTempletForm.value.constitutional.toString()
    let arr1 = [];
    arr1.push(
      this.fb.group({
        AdmissionMode: new FormControl(this.submitpayload.AdmissionMode),
        // Caste: new FormControl(this.submitpayload.Caste),
        IsHandicap: new FormControl(this.submitpayload.IsHandicap),
        SchemaQuota: new FormControl(SchemaQuota),
        SocialReservation: new FormControl(SocialReservation),
        StudentStatus: new FormControl(StudentStatus),
        StudentType: new FormControl(StudentType),
        TemplateName: new FormControl(this.submitpayload.TemplateName),
        TemplateCode: new FormControl(this.submitpayload.TemplateCode),
        FeeType: new FormControl(this.submitpayload.FeeType),
        Currency: new FormControl(this.submitpayload.Currency),
        constitutional: new FormControl(constitutional),
        StuStype: new FormControl(this.submitpayload.StuStype),
        SubCount: new FormControl(this.submitpayload.SubCount),
        FeeHead: new FormControl(''),
        FeeAmount: new FormControl(''),
        FeeLevel: new FormControl(this.submitpayload.FeeLevel),
        EmId: new FormControl(this.submitpayload.EmId),
      })
    );
    this.umsService.addFeeTemplet(arr1[0].value).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.submitFeeHead();
        } else {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.dialogRef2.close();
          });
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  submitFeeHead() {
    this.spinner.show();
    this.submitpayload = this.feeTempletForm.value;
    let abcd = this.feeTempletForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            TemplateCode: new FormControl(this.submitpayload.TemplateCode),
            FeeHead: new FormControl(element.FeeHead),
            FeeAmount: new FormControl(parseInt(element.FeeAmount)),
          })
        );
        this.umsService.FeeTemplet(arr1[0].value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false;
              this.errMsg = res.message;
            }
          },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          }
        );
      });
    });
   bar.then(() => {
  if (iserror == false) {
    let data = {};
    data['message'] = 'Submitted Successfully';
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
      AlertBoxComponent,
      data
    );
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef2.close();
      this.router.navigate(['/Fee-Templet']); 
    });

  } else {
  }
  });
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  prepopulation(id) {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = id.TemplateCode;
    payload['FeeType'] = '';
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      if (res.status) {
        this.FeeExam = true;
        this.spinner.hide()
        let data = res.data[0];
        if (res.data[0]['FeeLevel'] != null) {
          this.fetchFeeLevel();
          this.FeeLvlShow = true;
        } else if (res.data[0]['FeeLevel'] == null) {
          this.FeeLvlShow = false;
        }
        if (data['FeeType'] === 'EF') {
          this.TypeShow = true;
          this.feeTempletForm.controls['StuStype'].setValidators([Validators.required]);
          this.feeTempletForm.controls['StuStype'].updateValueAndValidity();
          
          if (data['StuStype'] === 'R') {
            this.SubCountShow = true;
            this.updateSubCountValidation();
          }
        } else {
          this.TypeShow = false;
          this.SubCountShow = false;
        }

        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.isDelete = false;
        this.FTdisable = false;
        this.isUpdate = true;
        let studentType = data.StudentType.split(',');
        let StudentStatus = data.StudentStatus.split(',');
        let constitutional = data.constitutional.split(',');
        let SocialReservation = data.SocialReservation.split(',');
        let SchemaQuota = data.SchemaQuota.split(',');
        // let AdmissionMode = data.AdmissionMode.split(',')
        this.feeTempletForm = this.fb.group({
          TemplateName: new FormControl(data.TemplateName, [
            Validators.required,
          ]),
          TemplateCode: new FormControl(data.TemplateCode, [
            Validators.required,
          ]),
          StudentType: new FormControl(studentType, [Validators.required]),
          StudentStatus: new FormControl(StudentStatus, [Validators.required]),
          constitutional: new FormControl(constitutional, [
            Validators.required,
          ]),
          FeeType: new FormControl(data.FeeType, [Validators.required]),
          FeeLevel: new FormControl(data.FeeLevel),
          EmId: new FormControl(data.EmId),
          StuStype: new FormControl(data.StuStype || ''),
          SubCount: new FormControl(data.SubCount || ''),
          Currency: new FormControl(data.Currency, [Validators.required]),
          // Caste: new FormControl(data.Caste,),
          SocialReservation: new FormControl(SocialReservation, [
            Validators.required,
          ]),
          IsHandicap: new FormControl(data.IsHandicap, [Validators.required]),
          SchemaQuota: new FormControl(SchemaQuota, [Validators.required]),
          AdmissionMode: new FormControl(data.AdmissionMode, [
            Validators.required,
          ]),
          feeHeadArray: new FormArray([]),
        });
        this.FeeTable = res.data;
        this.arr = this.FeeTable;
        this.FeeTable.forEach((element, i) => {
          const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              ClgUni: new FormControl(element['Uni_Colg']),
              Purpose: new FormControl(element['Purpose']),
              FeeAmount: new FormControl(element.FeeAmount, [
                Validators.required,
                Validators.pattern('^[0-9]*$'),
              ]),
            })
          );
          this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
        });
        // this.fetchCast(data.constitutional)
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  update() {
    this.submitpayload = this.feeTempletForm.value;
    if (this.feeTempletForm.invalid) {
      this.feeTempletForm.get('TemplateName').markAsTouched();
      this.feeTempletForm.get('TemplateCode').markAsTouched();
      this.feeTempletForm.get('StudentType').markAsTouched();
      this.feeTempletForm.get('StudentStatus').markAsTouched();
      this.feeTempletForm.get('constitutional').markAsTouched();
      // this.feeTempletForm.get('Caste').markAsTouched();
      this.feeTempletForm.get('FeeType').markAsTouched();
      this.feeTempletForm.get('SocialReservation').markAsTouched();
      // this.feeTempletForm.get('JNKMigration').markAsTouched();
      this.feeTempletForm.get('IsHandicap').markAsTouched();
      this.feeTempletForm.get('SchemaQuota').markAsTouched();
      this.feeTempletForm.get('AdmissionMode').markAsTouched();
      this.feeTempletForm.get('Currency').markAsTouched();
      
      if (this.TypeShow) {
        this.feeTempletForm.get('StuStype').markAsTouched();
      }
      if (this.SubCountShow) {
        this.feeTempletForm.get('SubCount').markAsTouched();
      }
      
      let x = (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
      x.forEach((element) => {
        element['controls']['FeeHead'].markAsTouched();
        element['controls']['FeeAmount'].markAsTouched();
      });
    } else {
      this.updateFeeTemplet();
    }
  }

  updateFeeTemplet() {
    this.spinner.show();
    this.submitpayload = this.feeTempletForm.value;
    // let AdmissionMode = this.submitpayload.AdmissionMode.length === 1 ? this.submitpayload.AdmissionMode : this.submitpayload.AdmissionMode.join(',');
    let SchemaQuota =
      this.submitpayload.SchemaQuota.length === 1
        ? this.submitpayload.SchemaQuota
        : this.submitpayload.SchemaQuota.join(',');

    let SocialReservation =
      this.submitpayload.SocialReservation.length === 1
        ? this.submitpayload.SocialReservation
        : this.submitpayload.SocialReservation.join(',');

    let StudentStatus =
      this.submitpayload.StudentStatus.length === 1
        ? this.submitpayload.StudentStatus
        : this.submitpayload.StudentStatus.join(',');

    let StudentType =
      this.submitpayload.StudentType.length === 1
        ? this.submitpayload.StudentType
        : this.submitpayload.StudentType.join(',');

    let constitutional =
      this.submitpayload.constitutional.length === 1
        ? this.submitpayload.constitutional
        : this.submitpayload.constitutional.join(',');

    let arr1 = [];
    arr1.push(
      this.fb.group({
        AdmissionMode: new FormControl(this.submitpayload.AdmissionMode),
        // Caste: new FormControl(this.submitpayload.Caste),
        IsHandicap: new FormControl(this.submitpayload.IsHandicap),
        SchemaQuota: new FormControl(SchemaQuota),
        SocialReservation: new FormControl(SocialReservation),
        StudentStatus: new FormControl(StudentStatus),
        StudentType: new FormControl(StudentType),
        TemplateName: new FormControl(this.submitpayload.TemplateName),
        TemplateCode: new FormControl(this.submitpayload.TemplateCode),
        FeeType: new FormControl(this.submitpayload.FeeType),
        FeeLevel: new FormControl(this.submitpayload.FeeLevel),
        EmId: new FormControl(this.submitpayload.EmId),
        Currency: new FormControl(this.submitpayload.Currency),
        constitutional: new FormControl(constitutional),
        StuStype: new FormControl(this.submitpayload.StuStype),
        SubCount: new FormControl(this.submitpayload.SubCount),
        FeeHead: new FormControl(''),
        FeeAmount: new FormControl(''),
      })
    );
    this.umsService.updateFeeTemplet(arr1[0].value).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.submitFeeHead();
          // this.updateFee();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  updateFee() {
    this.spinner.show();
    this.submitpayload = this.feeTempletForm.value;
    let abcd = this.feeTempletForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            TemplateCode: new FormControl(this.submitpayload.TemplateCode),
            FeeHead: new FormControl(element.FeeHead),
            FeeAmount: new FormControl(element.FeeAmount),
          })
        );
        this.umsService.updateFeeTemplet(arr1[0].value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false;
              this.errMsg = res.message;
            }
          },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          }
        );
      });
    });
    bar.then(() => {
      if (iserror == false) {
        let data = {};
        data['message'] = 'Submitted Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      } else {
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    });
  }

  deletedata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  prepopulationForDelete(id) {
    this.spinner.show()
    const payload = {};
    payload['TemplateCode'] = id.TemplateCode;
    payload['FeeType'] = '';
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        let data = res.data[0];
        if (res.data[0]['FeeLevel'] != null) {
          this.fetchFeeLevel();
          this.FeeLvlShow = true;
        } else if (res.data[0]['FeeLevel'] == null) {
          this.FeeLvlShow = false;
        }
        
        if (data['FeeType'] === 'EF') {
          this.TypeShow = true;
          if (data['StuStype'] === 'R') {
            this.SubCountShow = true;
          }
        } else {
          this.TypeShow = false;
          this.SubCountShow = false;
        }
        
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        this.isDelete = true;
        this.FTdisable = false;
        this.isUpdate = false;
        let studentType = data.StudentType.split(',');
        let StudentStatus = data.StudentStatus.split(',');
        let constitutional = data.constitutional.split(',');
        let SocialReservation = data.SocialReservation.split(',');
        let SchemaQuota = data.SchemaQuota.split(',');
        // let AdmissionMode = data.AdmissionMode.split(',')
        this.feeTempletForm = this.fb.group({
          TemplateName: new FormControl(data.TemplateName, [
            Validators.required,
          ]),
          TemplateCode: new FormControl(data.TemplateCode, [
            Validators.required,
          ]),
          StudentType: new FormControl(studentType, [Validators.required]),
          StudentStatus: new FormControl(StudentStatus, [Validators.required]),
          constitutional: new FormControl(constitutional, [
            Validators.required,
          ]),
          FeeType: new FormControl(data.FeeType, [Validators.required]),
          FeeLevel: new FormControl(data.FeeLevel),
          EmId: new FormControl(data.EmId),
          StuStype: new FormControl(data.StuStype || ''),
          SubCount: new FormControl(data.SubCount || ''),
          Currency: new FormControl(data.Currency, [Validators.required]),
          // Caste: new FormControl(data.Caste,),
          SocialReservation: new FormControl(SocialReservation, [
            Validators.required,
          ]),
          IsHandicap: new FormControl(data.IsHandicap, [Validators.required]),
          SchemaQuota: new FormControl(SchemaQuota, [Validators.required]),
          AdmissionMode: new FormControl(data.AdmissionMode, [
            Validators.required,
          ]),
          feeHeadArray: new FormArray([]),
        });
        this.FeeTable = res.data;
        this.FeeTable.forEach((element, i) => {
          const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              ClgUni: new FormControl(),
              Purpose: new FormControl(),
              FeeAmount: new FormControl(element.FeeAmount, [
                Validators.required,
                Validators.pattern('^[0-9]*$'),
              ]),
            })
          );
          this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
        });
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  DeletetheRecord() {
    const data = {};
    // data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['message'] =
      'For this template code all mapped criteria will be deleted, do you want to continue?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.delete(this.feeTempletForm.value);
        this.dialogRef2.close();
      } else {
        // this.ngOnInit();
        this.dialogRef2.close();
      }
    });
  }

  delete(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        TemplateName: id.TemplateName,
        TemplateCode: id.TemplateCode,
        StudentType: id.StudentType[0],
        StudentStatus: id.StudentStatus[0],
        constitutional: id.constitutional[0],
        FeeType: id.FeeType,
        FeeLevel: id.FeeLevel[0],
        EmId: id.EmId[0],
        Currency: id.Currency,
        // Caste: id.Caste,
        StuStype: id.StuStype,
        SubCount: id.SubCount,
        SocialReservation: id.SocialReservation[0],
        IsHandicap: id.IsHandicap,
        SchemaQuota: id.SchemaQuota[0],
        AdmissionMode: id.AdmissionMode[0],
        FeeAmount: id.feeHeadArray[0]['FeeAmount'],
        FeeHead: id.feeHeadArray[0]['FeeHead'],
        // FeeHead: id.FeeHead,
        // FeeAmount: id.FeeAmount,
      },
    };
    this.httpClient
      .delete(this.APIService + '/fees/feetemplate', options)
      .subscribe(
        (s) => {
          this.spinner.hide();
          // this.spinner.hide();
          let cc = [];
          cc.push(s);
          let data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ngOnInit();
          });
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
          // this.umsService.openSnackbar(ERROR.error.message);
        }
      );
  }

  clickHead(item, i) {
    let tempHead = [];
    this.headdList[i] = [];
    let ClgUni = item.Uni_Colg;
    let Purpose = item.Purpose;
    let tempsrno = [];
    let tempArr = this.feeTempletForm.get('feeHeadArray').value;
    let control = (<FormArray>this.feeTempletForm.get('feeHeadArray')).at(i);
    control.patchValue({
      ClgUni: ClgUni,
      Purpose: Purpose,
    });
    const payload = {};
    this.umsService.getFeeHead(payload).subscribe((res) => {
      let data = res.data;
      if (res.message !== 'No Data Found') {
        res.data.forEach((element) => {
          tempsrno.push(element);
        });

        this.headdList[i] = tempsrno;
        let feeHeadd = control.get('FeeHead').value;
        tempHead = this.headdList[i];
        tempArr.forEach((element) => {
          if (element.FeeHead == feeHeadd) {
            tempHead = tempHead.filter((m) => m.HeadCode != element.FeeHead);
          }
        });
        this.headdList[i] = tempHead;
      } else {
        this.headdList[i] = [];
      }
    });
  }

  fetchCurrency() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'CU';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide()
          this.CurrencyList = res.data;
          this.filteredCurrencyList = this.CurrencyList.slice();
        } else {
          this.spinner.hide()
          this.CurrencyList = [];
          this.filteredCurrencyList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        this.CurrencyList = [];
        this.filteredCurrencyList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  changeCurreancy(item) {
    if (item == 'NRI') {
      this.feeTempletForm.controls['Currency'].setValue('USD');
    } else {
      this.feeTempletForm.controls['Currency'].setValue('INR');
    }
  }

  getExamList() {
    this.spinner.show();
    const payload = {};
    this.umsService.getExam(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.examList = res.data;
          this.filteredListExam = this.examList.slice();
        } else {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);
      }
    );
  }

  getScretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.InstId = res.projectPharam['ClubPartTrans'];
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
}
 
 
